import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { MessageSquare, Send } from "lucide-react";

export const MessageDialog = ({ 
  open, 
  onOpenChange, 
  recipient, 
  messageText, 
  setMessageText, 
  onSend, 
  sending 
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0A0A0A] border-white/10 text-white max-w-md">
        <DialogHeader>
          <DialogTitle className="font-['Unbounded'] flex items-center gap-2">
            <MessageSquare className="w-5 h-5 text-blue-400" />
            Send Message
          </DialogTitle>
          <DialogDescription className="text-[#94A3B8]">
            Send a notification message to {recipient?.name}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label className="text-[#94A3B8]">Message</Label>
            <Textarea
              value={messageText}
              onChange={(e) => setMessageText(e.target.value)}
              placeholder="Enter your message... (e.g., 'Please upload your ID document to complete your profile')"
              className="bg-black/50 border-white/10 text-white min-h-[120px]"
            />
          </div>
          <div className="flex gap-2 pt-2">
            <Button
              variant="outline"
              onClick={() => {
                onOpenChange(false);
                setMessageText("");
              }}
              className="flex-1 border-white/20 text-[#94A3B8]"
            >
              Cancel
            </Button>
            <Button
              onClick={onSend}
              disabled={sending || !messageText.trim()}
              className="flex-1 bg-blue-500 text-white hover:bg-blue-600"
            >
              {sending ? (
                <span className="flex items-center gap-2">
                  <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  Sending...
                </span>
              ) : (
                <>
                  <Send className="w-4 h-4 mr-2" />
                  Send Message
                </>
              )}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
